import { styled, Box } from "@mui/material";

export const MandatoryBadge = styled(Box, {
  shouldForwardProp: prop => prop !== "close",
})(({ close }) => ({
  width: "8px",
  minWidth: "8px",
  height: "8px",
  backgroundColor: "#EF404B",
  borderRadius: "50%",
  ...(close && {
    position: "absolute",
    right: "0px",
    top: "0px"
  })
}));
